<template>
  <notification-card :iso-timestamp="n['@timestamp']" :title="title" icon="keyboard" :iconClass="`has-text-${variant}`">
    <template #menu>
      <NotificationMenu :n="n" :variant="variant" />
    </template>
    <template v-if="attCount > 0" #attachments_menu>
      <AttachmentsMenu :n="n" />
    </template>
    <template v-if="attCount > 0" #attachments>
      <AttachmentsViewer :n="n" />
    </template>
    <b-tag v-if="n.metaData['package-name']" class="mb-2" size="is-medium" :type="`is-${variant}`">{{ n.metaData['package-name'] }}</b-tag>
    <p>&ldquo;{{ n.metaData.content }}&rdquo;</p>
  </notification-card>
</template>

<script>
import { pascalToHuman } from '@/services/text/humanify'
import attachments from '@/services/attachments'

export default {
  props: {
    n: Object
  },
  computed: {
    title () { return pascalToHuman(this.n.metaData['policy-set-rule']) },
    attCount () { return attachments.parse(this.n).all.length },
    variant () { 
      if (this.title.toLowerCase().indexOf('keyword') !== -1) return 'danger'
      return 'info'
    }
  }
}
</script>